import { jsxs as n, jsx as o } from "react/jsx-runtime";
import { Modal as s, ModalOverlay as i, ModalContent as m } from "@chakra-ui/react";
function u({
  children: t,
  size: e = "sm",
  scrollBehavior: a = "inside",
  autoFocus: r = !1,
  isCentered: d = !0,
  ...l
}) {
  return /* @__PURE__ */ n(
    s,
    {
      variant: { base: "bottomSheet", md: "default" },
      scrollBehavior: a,
      motionPreset: "slideInBottom",
      autoFocus: r,
      size: e,
      isCentered: d,
      ...l,
      children: [
        /* @__PURE__ */ o(i, {}),
        /* @__PURE__ */ o(m, { children: t })
      ]
    }
  );
}
export {
  u as Modal
};
